var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgSearchDefault = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "currentColor",
  "aria-hidden": true,
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m15.852 14.635-3.776-3.776c-.094-.062-.187-.125-.28-.125h-.407a6.53 6.53 0 0 0 1.592-4.244C12.98 2.933 10.048 0 6.49 0 2.9 0 0 2.933 0 6.49a6.486 6.486 0 0 0 6.49 6.491c1.623 0 3.09-.593 4.244-1.56v.405q0 .141.094.281l3.776 3.776c.155.156.405.156.53 0l.718-.718c.156-.124.156-.374 0-.53M6.49 11.483A4.97 4.97 0 0 1 1.498 6.49 4.987 4.987 0 0 1 6.49 1.498a5.007 5.007 0 0 1 4.993 4.992 4.987 4.987 0 0 1-4.993 4.993"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSearchDefault);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;